module.exports = __webpack_public_path__ + "img/default_pattern_02_m.2aaea452.png";